import BaseEntity from '../base/BaseEntity.model';
import Persona from './persona.model';
import Telefono from '../telefono.model';

export default class PersonaTelefono extends BaseEntity{
    public personaId?: number;
    public telefonoId?: number;
    public persona?: Persona;
    public telefono?: Telefono;
    public matutino?: boolean;
    public vespertino?: boolean;
    public nocturno?: boolean;
    public diaCompleto?: boolean;
    
    constructor(){
        super();
        this.init();
    }

    init(){
        this.id = undefined;
        this.matutino = false;
        this.vespertino = false;
        this.nocturno = false;
        this.diaCompleto = false;
        this.personaId = undefined;
        this.telefonoId = undefined;
        this.persona = undefined;
        this.telefono = undefined;
    }
}
